import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { Button, Typography } from "@mui/material";
import TenderTable from "./TenderTable";
import axios from "axios";
import VQTable from "./VQTable";
import BidsTable from "./TechnicalHead/BidsTable";
import QueryTable from "./QueryTable";
import ItemCount from "../../utils/ItemCount";
import { useNavigate } from "react-router-dom";

const TechnicalHeadDashboard = () => {
  const [tenders, setTenders] = useState();
  const [vq, setVq] = useState();
  const [query, setQuery] = useState();
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const [activeTab, setActiveTab] = useState("QUERY");
  const [isLoading, setIsLoading] = useState(true);
  const [isVQLoading, setIsVQLoading] = useState(true);
  const [isQueryLoading, setIsQueryLoading] = useState(true);
  const [pendingActions, setPendingActions] = useState(false);
  const [queryCount, setQueryCount] = useState(0);
  const [vendorCount, setVendorCount] = useState(0);
  const [bidCount, setBidCount] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const getQueryCount = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/query/item?username=${storedUser.username}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setQueryCount(res.data);
      } catch (error) {
        console.log(error);
      }
    };
    getQueryCount();
    const getVendorCount = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/tender?username=${storedUser.username}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setVendorCount(res.data.length);
      } catch (error) {
        console.log(error);
      }
    };
    getVendorCount();
    const getBidCount = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/bid/item?username=${storedUser.username}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setBidCount(res.data);
      } catch (error) {
        console.log(error);
      }
    };
    getBidCount();
  }, []);

  useEffect(() => {
    if (activeTab === "VENDOR") {
      const getTenders = async () => {
        setTenders();
        try {
          const res = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/tender?username=${storedUser.username}`,
            { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
          );
          setTenders(res.data);
          setIsLoading(false);
        } catch (error) {
          console.log(error);
        }
      };
      getTenders();
    } else if (activeTab === "BIDS") {
      const getBidsByTender = async () => {
        localStorage.removeItem("tab");
        try {
          const res = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/bid?username=${storedUser.username}`,
            { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
          );
          setTenders(res.data);
          setIsLoading(false);
        } catch (error) {
          console.log(error);
        }
      };
      getBidsByTender();
    }
  }, [activeTab]);

  const getVendorTenders = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/vendor-tender/org?username=${storedUser.username}`,
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setVq(res.data);
      setIsVQLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const getQuery = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/query/get-tenders?username=${storedUser.username}`,
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setQuery(res.data);
      setIsQueryLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (activeTab === "VQ") {
      getVendorTenders();
    }
    if (activeTab === "QUERY") {
      getQuery();
    }
  }, [activeTab]);

  useEffect(() => {
    if (localStorage.getItem("pending")) {
      setActiveTab("VQ");
      setPendingActions(true);
      localStorage.removeItem("pending");
    }
  }, []);
  return (
    <Box sx={{ textAlign: "center" }}>
      <Box className="dashboard-container" sx={{ height: 400, width: "100%" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mb: 2,
            borderBottom: "1px solid #D1D1D1",
          }}
        >
          <Box
            sx={{
              display: "flex",
              gap: 1,
            }}
          >
            <Button
              className={`dashboard-btns ${
                activeTab === "QUERY" ? "active" : ""
              }`}
              onClick={() => {
                setActiveTab("QUERY");
                setIsLoading(true);
              }}
            >
              Query
              <ItemCount count={queryCount} />
            </Button>
            <Button
              className={`dashboard-btns ${
                activeTab === "VENDOR" ? "active" : ""
              }`}
              onClick={() => {
                setActiveTab("VENDOR");
                setIsLoading(true);
              }}
            >
              Vendor Qualification <ItemCount count={vendorCount} />
            </Button>
            <Button
              className={`dashboard-btns ${
                activeTab === "BIDS" ? "active" : ""
              }`}
              onClick={() => {
                setActiveTab("BIDS");
                setIsLoading(true);
              }}
            >
              Bids Received <ItemCount count={bidCount} />
            </Button>
          </Box>
          <Box>
            <Button
              className="pending-btn"
              onClick={() => {
                navigate("/dashboard/pending-actions")
                setActiveTab("GROUPED_QUERY");
              }}
            >
              My Pending actions
            </Button>
          </Box>
        </Box>
        {activeTab === "VENDOR" ? (
          <TenderTable
            tenders={tenders}
            activeTab={activeTab}
            isLoading={isLoading}
          />
        ) : activeTab === "BIDS" ? (
          <BidsTable
            tenders={tenders}
            isLoading={isLoading}
            storedUser={storedUser}
          />
        ) : activeTab === "QUERY" ? (
          <QueryTable tenders={query} isLoading={isQueryLoading} />
        ) : null}
      </Box>
    </Box>
  );
};

export default TechnicalHeadDashboard;
